module.exports = __webpack_public_path__ + "img/load-3-1.b78eedc8.png";